





















































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

import {
	isConsentConditionWithParams,
	isWaterExport,
	OrgsModule,
	WaterExportModule,
	WaterExportStatuses,
} from '@/modules';
import Toast from '@/components/display/toast.vue';
import { ConsentWithId, Org, WaterExport, WaterMeter } from '@/api';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: { SaveCancelButtons },
})
export default class WaterExportEdit extends Vue {
	@Prop() waterExportId!: number | undefined;
	@Prop() waterMeters!: WaterMeter[];
	@Prop() productId!: number;
	@Prop() consent: ConsentWithId | undefined;

	exportTargets: Org[] = [];
	waterExportModule: WaterExportModule;
	orgModule: OrgsModule;
	waterExport: WaterExport | undefined;
	loaded: boolean = false;
	WaterExportStatuses = WaterExportStatuses;

	constructor() {
		super();
		this.waterExportModule = new WaterExportModule();
		this.orgModule = new OrgsModule();

		this.waterExport = {
			productId: this.productId,
			targetOrgId: undefined,
			status: undefined,
			waterMeterIds: [],
			consentIdentifier: undefined,
		};
	}

	public mounted() {
		this.load();
	}

	async load() {
		this.exportTargets = await this.orgModule.getFtpTargets();
		if (this.exportTargets && this.exportTargets.length) {
			this.exportTargets.sort((a, b) => (a.name > b.name ? 1 : -1));
		}

		if (this.waterExportId != undefined) {
			this.waterExport = await this.waterExportModule.get(this.waterExportId);
		} else if (this.consent !== undefined) {
			this.waterExport = this.waterExport || {};
			if (this.consent.councilId != null) {
				this.waterExport.targetOrgId = this.consent.councilId;
			}
			if (this.consent.consentIdentifier != undefined) {
				this.waterExport.consentIdentifier = this.consent.consentIdentifier;
			}
		}

		this.loaded = true;
	}

	async handleSubmit(e: any) {
		if (this.waterExport) {
			if (!isWaterExport(this.waterExport)) {
				new Toast().makeToast(
					'Validation of the water export parameters failed',
					'Invalid parameters',
					'danger',
				);
			} else {
				try {
					await this.waterExportModule.save(this.waterExport, this.waterExportId);
				} catch (ex) {
					console.error(ex);
					new Toast().makeToast(
						`Error during save - ${ex.message} `,
						'ERROR - Failed to save ',
						'danger',
					);
				}
				this.$emit('closeModal');
				this.$emit('reloadConsent');
			}
		}
	}
}
